export default __webpack_public_path__ + "static/media/insta4.3e2e6fb9.png";